import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.OtherRequirement,
	portal: 'SP',
};

export type SPOtherRequirementCardLocNames = `SPOtherRequirementCardChange`;

export const spOtherRequirementCardLocs: LocDefs<SPOtherRequirementCardLocNames> = {
	SPOtherRequirementCardChange: {
		defaultValue: 'Change',
		description:
			'The change button text for the other requirement card on the other requirements page.',
		displayPath: 'Catalogs|Other Requirements|Nav Card|Change',
		displayType: 'Content',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirement.Button.ChangeSelectedCredential',
		...sharedProperties,
	},
};

export type SPOtherRequirementCardLocType = LocMap<SPOtherRequirementCardLocNames>;
